module.exports = __webpack_public_path__ + "static/media/outdoor_outfitter_background_for_store_mural_2013.61152a88.webp";